export default {
    getFullName(user) {
        return `${user.surname} ${user.name} ${user.middleName}`
    }
}